import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationChoroplethIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M649.333 62.8921L932.731 133.742C948.757 137.748 960 152.147 960 168.667V924C960 936.477 953.54 948.064 942.926 954.623C932.313 961.183 919.06 961.779 907.9 956.199L649.333 826.916L374.667 964.249L83.9003 818.866C71.7041 812.768 64 800.302 64 786.667V100C64 88.9144 69.1074 78.4469 77.8452 71.6246C86.5829 64.8024 97.9766 62.3862 108.731 65.0749L374.667 131.559L649.333 62.8921ZM136 146.108V764.417L374.667 883.751L649.333 746.417L888 865.751V196.775L649.333 137.108L374.667 205.775L136 146.108Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M685.5 683.946L816 749V253L685.5 220.081V683.946Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M613.5 683.935V490.382L410.5 566.23V785.065L613.5 683.935Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M410.5 270.533V489.368L613.5 413.52V219.967L410.5 270.533Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M338.5 785.054V270.527L208 238V720L338.5 785.054Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationChoroplethIcon
};
